module.exports = __webpack_public_path__ + "static/media/FlightBooking.405eb48c.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/GuruProfile/FlightBooking.svg
// module id = 2602
// module chunks = 0